/* eslint-disable import/no-named-as-default */
import React, { Component, Fragment, ReactNode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Timeline from "../../Charts/Timeline";
import AnalyticsWidgetLoading from "../../shared/loaders/AnalyticsWidgetLoading";
import { Wrapper } from "../styles/charts-styles";
import { ChartTitle } from "../styles/employer-analytics-styles";
import ReactTooltip from "react-tooltip";

export interface IFillRateProps {
  fillRate: {
    months?: Date[];
    values?: number[];
  };
  fillRateWidgetLoader: boolean;
}

export class FillRate extends Component<IFillRateProps> {
  static propTypes = {
    fillRate: PropTypes.shape({
      months: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
      values: PropTypes.arrayOf(PropTypes.number),
    }),
    fillRateWidgetLoader: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    fillRate: {
      months: [],
      values: [],
    },
  };

  render(): ReactNode {
    const { fillRate, fillRateWidgetLoader } = this.props;

    const fillRateOptions = {
      series: [
        {
          name: "Fill Rate",
          data: fillRate.values,
        },
      ],
      options: {
        height: 350,
        colors: ["#402680"],

        chart: {
          type: "line",
          offsetY: -5,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: [1],
          curve: "straight",
        },
        markers: {
          size: 5,
          radius: 5,
          shape: "circle",
        },

        tooltip: {
          x: {
            formatter: function (value) {
              const date = new Date(value);
              return date.toLocaleString("default", { month: "short" });
            },
          },

          y: [
            {
              title: {
                formatter: (val: string) => val,
              },
            },
          ],
        },
        xaxis: {
          type: "datetime",
          categories: fillRate.months.map((date) => date.getTime()),
          title: {
            text: "Time",
          },
        },
        yaxis: {
          title: {
            text: "Fill Rate %",
          },
        },
        legend: {
          offsetY: 5,
          tooltipHoverFormatter: (
            val: string,
            opts: {
              w: {
                globals: { series: number[][] };
              };
              seriesIndex: number;
              dataPointIndex: number;
            }
          ) => {
            const value = `${val} - ${
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex]
            } `;
            return value;
          },
        },
      },
    };

    return (
      <Fragment>
        <Wrapper className="animated fadeIn delay-5" id="fill-rate-widget">
          <AnalyticsWidgetLoading
            text="Updating..."
            active={fillRateWidgetLoader}
          />

          <Timeline
            graphOptions={fillRateOptions}
            dataTestId="fill-rate-per-sector-chart"
          />
          <ChartTitle
            marginBottom={20}
            data-test-id="fill-rate-per-sector-title"
            data-tip="Percentage of jobs filled vs jobs posted."
            data-for="fill-rate-per-sector-title-tooltip"
          >
            <ReactTooltip
              type="dark"
              aria-haspopup="true"
              id="fill-rate-per-sector-title-tooltip"
              className="tooltip-max-width"
            />
            Fill Rate
          </ChartTitle>
        </Wrapper>
      </Fragment>
    );
  }
}

interface IReduxState {
  employerAnalytics: {
    jobPerformanceData: {
      fillRate: {
        months: Date[];
        values: number[];
      };
    };
    fillRateWidgetLoader: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  fillRate: state.employerAnalytics.jobPerformanceData.fillRate,
  fillRateWidgetLoader: state.employerAnalytics.fillRateWidgetLoader,
});

export default connect(mapStateToProps, {})(FillRate);
